import { cva, type VariantProps } from 'class-variance-authority';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

const dotOuterVariants = cva(
  cn('flex items-center justify-center w-full h-full p-[3px] rounded-full'),
  {
    variants: {
      variant: {
        success: 'bg-illicitGreen-300',
        destructive: 'bg-desire-300',
        info: 'bg-blueBonnet-300',
      },
    },
    defaultVariants: {
      variant: 'success',
    },
  },
);

const dotInnerVariants = cva(cn('w-full h-full rounded-full'), {
  variants: {
    variant: {
      success: 'bg-illicitGreen-500',
      destructive: 'bg-desire-500',
      info: 'bg-blueBonnet-500',
    },
  },
  defaultVariants: {
    variant: 'success',
  },
});

interface IDotProps
  extends ComponentProps<'div'>,
    VariantProps<typeof dotOuterVariants> {
  outerClassName?: string;
  innerClassName?: string;
}

export function Dot({
  variant,
  className,
  outerClassName,
  innerClassName,
  ...props
}: IDotProps): JSX.Element {
  return (
    <div className={cn('size-4', className)} {...props}>
      <div
        className={cn(
          dotOuterVariants({
            variant,
          }),
          outerClassName,
        )}
      >
        <div
          className={cn(
            dotInnerVariants({
              variant,
            }),
            innerClassName,
          )}
        />
      </div>
    </div>
  );
}
